import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faArrowLeft,
    faMagnifyingGlass,
    faClock,
    faArrowRight,
    faHome,
} from '@fortawesome/free-solid-svg-icons'
import type { KbSearchResult } from '../types'

interface SearchResultsProps {
    query: string
    results: KbSearchResult[]
    onBack: () => void
    onSelectArticle: (slug: string) => void
}

const SearchResults = ({
    query,
    results,
    onBack,
    onSelectArticle,
}: SearchResultsProps) => {
    return (
        <section className="kb-search-results">
            <div className="kb-category-view__breadcrumb">
                <button onClick={onBack} className="kb-breadcrumb__link">
                    <FontAwesomeIcon icon={faHome} className="me-1" />
                    Knowledge Base
                </button>
                <span className="kb-breadcrumb__sep">/</span>
                <span className="kb-breadcrumb__current">Search Results</span>
            </div>

            <div className="kb-search-results__header">
                <button onClick={onBack} className="kb-category-view__back">
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <div>
                    <h1 className="kb-search-results__title">
                        Search Results
                    </h1>
                    <p className="kb-search-results__subtitle">
                        {results.length}{' '}
                        {results.length === 1 ? 'result' : 'results'} for "
                        <strong>{query}</strong>"
                    </p>
                </div>
            </div>

            {results.length === 0 ? (
                <div className="kb-search-results__empty">
                    <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="kb-search-results__empty-icon"
                    />
                    <h3>No results found</h3>
                    <p>
                        We couldn't find anything matching "{query}". Try
                        different keywords or{' '}
                        <button onClick={onBack} className="kb-link">
                            browse all categories
                        </button>
                        .
                    </p>
                </div>
            ) : (
                <div className="kb-search-results__list">
                    {results.map((result, idx) => (
                        <button
                            key={result.id}
                            className="kb-article-card"
                            onClick={() => onSelectArticle(result.slug)}
                            style={
                                {
                                    '--article-index': idx,
                                } as React.CSSProperties
                            }
                        >
                            <div className="kb-article-card__content">
                                <span className="kb-article-card__category-badge">
                                    {result.category_title}
                                </span>
                                <h3 className="kb-article-card__title">
                                    {result.title}
                                </h3>
                                <p className="kb-article-card__excerpt">
                                    {result.excerpt}
                                </p>
                                <div className="kb-article-card__meta">
                                    <span className="kb-article-card__time">
                                        <FontAwesomeIcon
                                            icon={faClock}
                                            className="me-1"
                                        />
                                        {result.reading_time} min read
                                    </span>
                                </div>
                            </div>
                            <div className="kb-article-card__arrow">
                                <FontAwesomeIcon icon={faArrowRight} />
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </section>
    )
}

export default SearchResults
